function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9706 13.1899V5.77831C19.9707 5.68472 19.9523 5.59203 19.9165 5.50556C19.8807 5.4191 19.8282 5.34054 19.762 5.2744L16.0295 1.54193C15.8962 1.40848 15.7154 1.33342 15.5268 1.33325H1.7114C1.52272 1.33325 1.34178 1.4082 1.20836 1.54162C1.07495 1.67503 1 1.85598 1 2.04465V24.3352C1 24.5238 1.07495 24.7048 1.20836 24.8382C1.34178 24.9716 1.52272 25.0466 1.7114 25.0466H9.29966M5.74266 10.8186H15.228M5.74266 6.07591H10.4853M5.74266 15.5612H9.29966M17.5448 19.0471L18.7304 17.8614C18.8539 17.7379 19.0004 17.6399 19.1618 17.573C19.3231 17.5062 19.496 17.4717 19.6707 17.4717C19.8453 17.4717 20.0182 17.5062 20.1796 17.573C20.3409 17.6399 20.4875 17.7379 20.6109 17.8614C20.86 18.1107 21 18.4487 21 18.8011C21 19.1535 20.86 19.4915 20.6109 19.7407L19.4252 20.9264L17.5448 19.0459L13.9984 22.5922C13.8211 22.7701 13.7049 22.9997 13.6665 23.2479L13.3772 25.094L15.2232 24.8059C15.4714 24.7674 15.701 24.6512 15.8789 24.4739L19.4241 20.9264",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.2280c338de0f67e3e108a768a14def04.svg";
export { ForwardRef as ReactComponent };